



















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Emit, Prop, PropSync } from 'vue-property-decorator'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import ContentEditor from '@/modules/content/components/shared/ContentEditor.vue'

@Component({
  components: {
    BaseInput,
    ContentEditor
  }
})
export default class AdminContentEditor extends Vue {
  @PropSync('content') contentSync!: string
  @PropSync('title') titleSync!: string
  @PropSync('lead') leadSync!: string

  @Prop() errorMessage!: string
  @Prop() error!: string

  private wordsCount: number = 0

  @Emit()
  private words(value: number) {
    this.wordsCount = value
  }
}
